
document.addEventListener('DOMContentLoaded', function () {
  var btns = document.querySelectorAll('.el-main-atc');
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var checked = document.querySelector('.kaching-bundles input[type="radio"]:checked');
      var variant = (checked && checked.dataset.kpzVariant) || btn.dataset.kpzVariant;
      if (!variant) return;
      var label = btn.querySelector('[data-atc-label]') || btn;
      var orig = label.textContent;
      btn.disabled = true; label.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variant, 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('atc failed');
        window.location.href = '/checkout';
      }).catch(function () {
        label.textContent = orig; btn.disabled = false;
      });
    });
  });
});
